import * as React from 'react';
import { CssVarsProvider, useColorScheme } from '@mui/joy/styles';
import { useSelector } from 'react-redux';
import { useThemeSlice } from './slice';
import { selectThemeKey } from './slice/selectors';
import { CssBaseline } from '@mui/joy';
import { theme } from './themes';

const ThemeHandler = ({ children }: { children: React.ReactNode }) => {
  const selectedTheme = useSelector(selectThemeKey);
  const { setMode } = useColorScheme();

  React.useEffect(() => {
    setMode(selectedTheme);
  }, [selectedTheme, setMode]);

  return <>{children}</>;
};

export const ThemeProvider = (props: { children: React.ReactNode }) => {
  useThemeSlice();
  const selectedTheme = useSelector(selectThemeKey);

  return (
    <>
      <CssVarsProvider
        theme={theme}
        defaultMode={selectedTheme}
        modeStorageKey="academix-mode"
        colorSchemeStorageKey="academix-color-scheme"
      >
        <CssBaseline />
        <ThemeHandler>{props.children}</ThemeHandler>
      </CssVarsProvider>
    </>
  );
};
